import { useState } from 'react';
import ChatTextboxView from './ChatTextbox.View';
import { ChatTextboxProps } from './types';

const ChatTextbox = (props: ChatTextboxProps) => {
  const { onSendMessage, disabled } = props;
  const [value, setValue] = useState('');
  const [inputKey, setInputKey] = useState(`input_textbox_${Date.now()}`);

  const onChange = (newValue: string) => {
    setValue(newValue);
  };

  const onSend = () => {
    const trimmedValue = value.trim();

    setValue(''); // Clear the input after sending
    setInputKey(`input_textbox_${Date.now()}`);

    onSendMessage(trimmedValue);
  };

  const onKeyPress = (event: React.KeyboardEvent<HTMLInputElement>) => {
    if (event.key === 'Enter' && !event.shiftKey) {
      event.preventDefault(); // Prevent default Enter behavior
      onSend();
    }
  };

  return (
    <ChatTextboxView
      inputKey={inputKey}
      disabled={disabled}
      onChange={onChange}
      value={value}
      onSend={onSend}
      onKeyPress={onKeyPress}
    />
  );
};

export default ChatTextbox;
